import React, { useState } from "react";
import { DraggableScrollContainer } from "../../atom/DraggableScrollContainer";
import { SectionHeading } from "../../atom/SectionHeading";
import { CornerUser } from "../../atom/CornerUser";
import { useTranslation } from "react-i18next";
import { useResource } from "../../../services";
import { ParticipantFile } from "../../../types/components";
import { useUserContext } from "../../../utils/contexts/UserProvider";
import { FilesUploaded } from "./FilesUploaded";
import { UploadFileModal } from "./UploadFileModal";
import { RemoveFileModal } from "./RemoveFileModal";
import { DocumentsTable } from "./DocumentsTable";
import { isStatusNotUploaded } from "../../../utils/status";
import { createResourceUrl } from "../../../utils/data";

export const Documents = () => {
  const { t } = useTranslation();
  const { user } = useUserContext();
  const [files, setFiles] = useState<File[] | null>(null);
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
  const [currentFile, setCurrentFile] = useState<ParticipantFile | null>(null);

  const { data, mutate } = useResource<ParticipantFile[]>(
    createResourceUrl("/common/participant-file", {
      include: ["type", "status", "file", "type.template"],
      filters: {
        "eq:participant_id": user?.id,
      },
    }),
    user,
  );

  const uploadedCount = data?.filter(({ status }) => !isStatusNotUploaded(status.code))?.length;

  return (
    <div className="flex flex-col flex-1 items-center w-full flex-grow">
      <div className="w-full overflow-hidden flex flex-col flex-grow">
        <DraggableScrollContainer className="m-[20px] overflow-y-auto select-none ml-[8px] bg-gray-100 flex-grow">
          <div className="flex flex-col gap-10">
            <div className="px-12 pt-10">
              <SectionHeading
                title={t("Documents")}
                subtitle={t(
                  "Manage your documents — Effortlessly view and organize all your files in one place.",
                )}
                subtitleClassName="max-w-[560px]"
                cornerComponent={<CornerUser />}
              />
            </div>

            <div className="flex flex-col bg-white ml-12 mr-[52px] mb-[75px] rounded-[6px] shadow">
              <FilesUploaded uploadedCount={uploadedCount} />
              <DocumentsTable
                data={data}
                setCurrentFile={setCurrentFile}
                setIsRemoveModalOpen={setIsRemoveModalOpen}
                setIsUploadModalOpen={setIsUploadModalOpen}
              />
            </div>
            <div className="flex-grow"></div>
          </div>
        </DraggableScrollContainer>

        <UploadFileModal
          isUploadModalOpen={isUploadModalOpen}
          setIsUploadModalOpen={setIsUploadModalOpen}
          files={files}
          setFiles={setFiles}
          currentFile={currentFile}
          mutate={mutate}
        />

        <RemoveFileModal
          file={currentFile}
          isRemoveModalOpen={isRemoveModalOpen}
          setIsRemoveModalOpen={setIsRemoveModalOpen}
          mutate={mutate}
        />
      </div>
    </div>
  );
};
